const c = [
	() => import("../../../src/routes/__layout.svelte"),
	() => import("../components/error.svelte"),
	() => import("../../../src/routes/index.svelte"),
	() => import("../../../src/routes/subscriptions.svelte"),
	() => import("../../../src/routes/playlists.svelte"),
	() => import("../../../src/routes/ipfs-404.svelte"),
	() => import("../../../src/routes/playlist.svelte"),
	() => import("../../../src/routes/settings.svelte"),
	() => import("../../../src/routes/trending.svelte"),
	() => import("../../../src/routes/channel.svelte"),
	() => import("../../../src/routes/popular.svelte"),
	() => import("../../../src/routes/search.svelte"),
	() => import("../../../src/routes/thanks.svelte"),
	() => import("../../../src/routes/embed.svelte"),
	() => import("../../../src/routes/watch.svelte")
];

const d = decodeURIComponent;

export const routes = [
	// src/routes/index.svelte
	[/^\/$/, [c[0], c[2]], [c[1]]],

	// src/routes/subscriptions.svelte
	[/^\/subscriptions\/?$/, [c[0], c[3]], [c[1]]],

	// src/routes/playlists.svelte
	[/^\/playlists\/?$/, [c[0], c[4]], [c[1]]],

	// src/routes/ipfs-404.svelte
	[/^\/ipfs-404\/?$/, [c[0], c[5]], [c[1]]],

	// src/routes/playlist.svelte
	[/^\/playlist\/?$/, [c[0], c[6]], [c[1]]],

	// src/routes/settings.svelte
	[/^\/settings\/?$/, [c[0], c[7]], [c[1]]],

	// src/routes/trending.svelte
	[/^\/trending\/?$/, [c[0], c[8]], [c[1]]],

	// src/routes/channel.svelte
	[/^\/channel\/?$/, [c[0], c[9]], [c[1]]],

	// src/routes/popular.svelte
	[/^\/popular\/?$/, [c[0], c[10]], [c[1]]],

	// src/routes/search.svelte
	[/^\/search\/?$/, [c[0], c[11]], [c[1]]],

	// src/routes/thanks.svelte
	[/^\/thanks\/?$/, [c[0], c[12]], [c[1]]],

	// src/routes/embed.svelte
	[/^\/embed\/?$/, [c[0], c[13]], [c[1]]],

	// src/routes/watch.svelte
	[/^\/watch\/?$/, [c[0], c[14]], [c[1]]]
];

export const fallback = [c[0](), c[1]()];